module.exports = __webpack_public_path__ + "static/Logo-Text-1179b8c3cb192766b8717932f1414901.svg";